/**
 * Where the last press landed, for a page that opens out of what opened it.
 *
 * A card opened from an ordinary link has no way of its own to know where it was opened from:
 * the link is a link, and the card is rendered somewhere else entirely, off the address. So the
 * press is remembered here as it happens — the near corner of the control pressed, where the
 * press was on one, and the point itself otherwise — and whatever opens next is laid there
 * rather than in the middle of nowhere.
 */
let last: { x: number; y: number } | undefined

if (typeof document !== 'undefined') {
  document.addEventListener(
    'pointerdown',
    (event) => {
      const target = event.target instanceof Element ? event.target.closest('a,button') : null
      const box = target?.getBoundingClientRect()
      last =
        box === undefined || box.width === 0
          ? { x: event.clientX, y: event.clientY }
          : { x: box.left, y: box.top }
    },
    { capture: true },
  )
  // A keyboard never presses anywhere, so what it opens arrives the ordinary way.
  document.addEventListener('keydown', () => {
    last = undefined
  })
}

export function lastPointer(): { x: number; y: number } | undefined {
  return last
}
